import React , { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { InputLabel, Select, MenuItem } from "@material-ui/core";
import { valorMes } from "../../../ducks/cotizacionDuck"
import { obtenerComisionesAgentePagadas } from "../../../ducks/cotizacionDuck"
import BackDrop from "../../../global/BackDrop"

const meses = [
    { value: 1, nombre: 'Enero' },
    { value: 2, nombre: 'Febrero' },
    { value: 3, nombre: 'Marzo' },
    { value: 4, nombre: 'Abril' },
    { value: 5, nombre: 'Mayo' },
    { value: 6, nombre: 'Junio' },
    { value: 7, nombre: 'Julio' },
    { value: 8, nombre: 'Agosto' },
    { value: 9, nombre: 'Septiembre' },
    { value: 10, nombre: 'Octubre' },
    { value: 11, nombre: 'Noviembre' },
    { value: 12, nombre: 'Diciembre' }
  ]

const CbMeses = () =>{

    const dispatch = useDispatch()
    const mes = useSelector(store => store.cotizacion.mes)
    const agente = useSelector(store => store.cotizacion.agente)
    const [isLoad, setIsLoad] = useState(false);

    useEffect(()=>{
        setIsLoad(true);
        dispatch(obtenerComisionesAgentePagadas()).then((Response) =>{
            setIsLoad(false)
        })
    },[dispatch, mes,agente])

    const handleSelectMes = (event) =>{
        dispatch(valorMes(event.target.value))
    }

    return(
        <div>
            <InputLabel id="lMeses">Mes de Pago</InputLabel>
                <Select
                    labelId="lMeses"
                    id="SMes"
                    name="mes"
                    value={mes}
                    onChange={handleSelectMes}
                    label="Mes">
                    <MenuItem value="opcion" disabled>
                        {"Seleccione una opción"}
                    </MenuItem>
                    {meses.map((mes, index) => (
                        <MenuItem key={index} value={mes.value}>
                            {mes.nombre}
                        </MenuItem>
                    ))}
                </Select>
                <BackDrop open={isLoad} />
        </div>
    )

}

export default CbMeses